import React from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import { createReduxStore } from "../../../utils/createReduxStore";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import CheckInModule from "./checkInModule";
import reducer from "./redux/checkInReducer";
import saga from "./redux/checkInSaga";

const CheckIn = ({ params, numberOfMonths, notifications }) => {
  return (
    <Provider store={createReduxStore(reducer, "checkIn", saga)}>
      <ErrorBoundary moduleName="checkIn" {...notifications}>
        <CheckInModule currentUser={params} numberOfMonths={numberOfMonths} />
      </ErrorBoundary>
    </Provider>
  );
};

export default CheckIn;

CheckIn.propTypes = {
  params: PropTypes.object,
  numberOfMonths: PropTypes.number,
  notifications: PropTypes.number
};
